export const VK_PIXEL_ID = '3798160';

export const VK_PIXEL_SCRIPT_ID = 'tmr-code';

export const VK_PIXEL_SCRIPT_SRC = 'https://top-fwz1.mail.ru/js/code.js';

interface VkPixelEvent {
  id: string;
  type: string;
  start?: number;
}

interface VkPixelQueue {
  push(event: VkPixelEvent): unknown;
}

declare global {
  interface Window {
    _tmr?: VkPixelQueue;
  }
}

let isInitialized = false;

export const initVkPixel = (): void => {
  if (typeof window === 'undefined' || isInitialized) return;
  isInitialized = true;

  if (!window._tmr) {
    const queue: VkPixelEvent[] = [];
    window._tmr = queue;
  }

  window._tmr.push({ id: VK_PIXEL_ID, type: 'pageView', start: Date.now() });

  if (document.getElementById(VK_PIXEL_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.async = true;
  script.id = VK_PIXEL_SCRIPT_ID;
  script.src = VK_PIXEL_SCRIPT_SRC;
  document.head.appendChild(script);
};
